import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import AccountActivationBaseMessage
  from '@/views/overseasSales/customerCenter/accountActivation/components/DetailForm.vue'
import { newClientEvaluationDetail } from '@/api/overseasSales/newClientEvaluation'

const __default__ = { name: 'DcCosOFbuAccountActivationEdit' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const data = ref({})
// 获取详情
const fetch = () => {
  let fetchId = -1
  /// 这里判断两次一种是草稿id一种是流程id
  if (route.query.accountActivationId) {
    fetchId = route.query.accountActivationId as unknown as number
  } else if (route.query.draftId) {
    fetchId = route.query.draftId as unknown as number
  }
  newClientEvaluationDetail({ id: fetchId }).then((res) => {
    if (res.data.business && res.data.business.businessType && res.data.business.businessType?.length > 0) {
      res.data.business.businessTypeSelect = res.data.business.businessType[0]
    }
    data.value = res.data
  })
}
const permissionBasic = {
  save: 'ofbu_potential_edit_btn',
  editCode: 'ofbu_potential_edit_name_or_code_btn'
}
onMounted(() => {
  fetch()
})

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(AccountActivationBaseMessage, {
            disabled: false,
            permissionPage: permissionBasic,
            data: data.value
          }, null, 8, ["data"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})